export default __webpack_public_path__ + "static/media/finish@3x.2b833926.png";